<script>
export default {
  props: ['id', 'campaignId'],
  data() {
    return {
      contentIndex: 0,
      campaign: null,
      error: false
    }
  },
  methods: {
    modalShow() {
      this.contentIndex = 0;

      this.apiGet(`/campaigns/${this.campaignId}`, { include: 'advertiser,campaignOrder' }).then((data) => {
        this.campaign = data;
      }).catch((error) => {
        this.$store.dispatch('layout/addPageError', error);
      })
    },
    clearCampaign() {
      this.campaign = null;
    }
  },
  computed: {
    ads() {
      const adsArray = [];

      if (this.campaign) {
        if (this.campaign.package.type === 'Digital' || this.campaign.package.type === 'Print & digital') {
          adsArray.push({
            name: 'Digital Ad - 300x250 MREC',
            component: () => import('@/components/previews/digital-300x250'),
            class: 'creative-preview-modal__component-wrapper',
            isCreativeProof: true,
          })
        }

        if (this.campaign.package.type === 'Digital' || this.campaign.package.type === 'Print & digital') {
          adsArray.push({
            name: 'Digital Ad - 160x600 Skyscraper',
            component: () => import('@/components/previews/digital-160x600'),
            class: 'creative-preview-modal__component-wrapper',
            isCreativeProof: true
          })
        }

        if (this.campaign.package.type === 'Digital' || this.campaign.package.type === 'Print & digital') {
          adsArray.push({
            name: 'Social - Facebook Main Photo',
            component: () => import('@/components/previews/facebook'),
            class: 'creative-preview-modal__component-wrapper',
            isCreativeProof: true
          })
        }

        if (this.campaign.package.type === 'Digital' || this.campaign.package.type === 'Print & digital') {
          adsArray.push({
            name: 'Native - Newsfeed and in App',
            component: () => import('@/components/previews/native'),
            class: 'creative-preview-modal__component-wrapper',
            isCreativeProof: true
          })
        }

        if (this.campaign.package.type === 'Print & digital') {
          adsArray.unshift({
            name: `Print Booking Advert Size - ${this.campaign.package.printSize}`,
            component: () => import('@/components/previews/print'),
            class: 'creative-preview-modal__component-wrapper',
            isCreativeProof: false
          })
        }

        if (this.campaign.package.type === 'Video') {
          adsArray.unshift({
            name: 'Video',
            component: () => import('@/components/previews/video'),
            class: 'video-preview-modal__component-wrapper',
            isCreativeProof: false
          })
        }

        if ((this.campaign.package.type === 'Digital' || this.campaign.package.type === 'Print & digital') && this.campaign.landingPage) {
          adsArray.push({
            name: 'Landing Page',
            component: () => import('@/components/previews/landing-page'),
            class: 'creative-preview-modal__landing-page-wrapper',
            isCreativeProof: true
          });
        }

        if ((this.campaign.package.type === 'Digital' || this.campaign.package.type === 'Print & digital') && this.campaign.campaignOrder && this.campaign.campaignOrder.signifiOrderEid) {
          adsArray.push({
            name: 'Live Creative Summary Page',
            component: () => import('@/components/previews/live-creative'),
            class: 'creative-preview-modal__live-creative-wrapper',
            isCreativeProof: false
          });
        }
      }

      return adsArray;
    }
  }
}
</script>

<template>
  <b-modal :id="id" centered size="lg" body-class="p-0 creative-preview-modal__modal " hide-footer hide-header @show="modalShow" @hide="clearCampaign">
    <div class="d-flex flex-column creative-preview-modal__wrapper">
      <div class="d-flex justify-content-between align-items-center px-3 py-2 creative-preview-modal__navbar" v-if="this.ads.length">
        <div class="d-flex">
          <h4 class="h5 mb-0 creative-preview-modal__title">{{ this.ads[contentIndex].name }}</h4>
        </div>
        <div class="creative-preview-modal__button-wrapper">
          <button class="creative-preview-modal__button creative-preview-modal__button--left" @click="() => this.contentIndex--" :disabled="this.contentIndex === 0">
            <i class="bx bxs-left-arrow px-1 font-size-14" />
          </button>
          <button class="creative-preview-modal__button creative-preview-modal__button--right" @click="() => this.contentIndex++" :disabled="this.contentIndex + 1 === this.ads.length">
            <i class="bx bxs-right-arrow px-1 font-size-14" />
          </button>
        </div>
      </div>

      <div class="d-flex justify-content-between mt-2 mb-0" v-if="this.ads.length">
        <p>
          <span v-if="this.ads[contentIndex].isCreativeProof">
            Creative proof
          </span>
        </p>
        <p>{{ contentIndex + 1 }} of {{ this.ads.length }}</p>
      </div>
      
      <b-alert v-if="error" show variant="danger" class="mt-5">Error loading campaign data, please try again later.</b-alert>

      <div v-else class="d-flex align-items-center justify-content-center creative-preview-modal__content">
        <div v-if="campaign">
          <div :class="this.ads[contentIndex].class">
            <component v-if="this.ads[contentIndex].component" :is="this.ads[contentIndex].component" :campaign="this.campaign" />            
          </div>
        </div>
        <div v-else>
          <i class="bx bx-loader-alt bx-spin text-primary font-size-22"></i>
        </div>
      </div>
    </div>
  </b-modal>
</template>
